<template>
  <div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <ToolListItem v-for="toolItem in toolList" :key="toolItem.slug" :tool-item="toolItem" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import ToolListItem from '&/ToolListItem.vue'

  defineProps<{
    toolList: array
  }>()
</script>
